import { motion, Variants } from "framer-motion";
import ChainSelector from "./chainSelector";
import { LanguageSwitcher, useTokenSiteText } from "./language";
export type NavType = {
  setTab: (arg0: string) => void;
  displayNav: boolean;
  setDisplayNav: (arg0: boolean) => void;
};
const Nav = ({ setTab, displayNav, setDisplayNav }: NavType): JSX.Element => {
  const { text } = useTokenSiteText();

  return (
    <>
      <div className="fixed top-4 md:top-5 left-3 right-3 md:left-8 md:right-8 h-24 z-50 ">
        <div className="flex items-start">
          <motion.button
            onClick={(e) => {
              setDisplayNav(!displayNav);
              e.nativeEvent.stopImmediatePropagation();
            }}
            className="z-10"
          >
            <motion.div
              variants={{
                open: { y: 0, x: 0 },
                closed: { y: 0, x: 0 },
              }}
              animate={displayNav ? "open" : "closed"}
              transition={{ duration: 0.4 }}
            >
              <img src="/icon.png" className="w-10 h-10 bg-white rounded-full shadow-[0px_0px_2px_2px_rgba(153,153,153,0.5)]"/>
            </motion.div>
          </motion.button>
          <motion.div
            variants={fadeToRight}
            initial="closed"
            animate={displayNav ? "open" : "closed"}
            className="hidden md:flex"
          >
            <ul className="text-white flex gap-10 mt-1">
              <li>
                <button
                  onClick={() => {
                    setTab("home");
                  }}
                  className="text-white hover:text-[#999] text-sm font-semibold"
                >{text.home}</button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setTab("dashboard");
                  }}
                  className="text-white hover:text-[#999]  text-sm font-semibold"
                >{text.dashboard}</button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setTab("reward");
                  }}
                  className="text-white hover:text-[#999]  text-sm font-semibold"
                >{text.reward}</button>
              </li>

            </ul>
          </motion.div>
          <div className="ml-auto flex items-center gap-1 md:gap-3">
            <ChainSelector />
            <LanguageSwitcher />
          </div>
        </div>

        <motion.div
          variants={fadeToBelow}
          initial="closed"
          animate={displayNav ? "open" : "closed"}
          className="md:hidden bg-black max-w-min p-2 rounded-xl mt-[-50px] ml-[-8px]"
        >
          <ul className="text-white flex flex-col gap-4 mt-14">
            <li>
              <button
                onClick={() => {
                  setTab("home");
                }}
                className="text-white hover:text-[#999] text-xs font-medium"
              >{text.home}</button>
            </li>
            <li>
              <button
                onClick={() => {
                  setTab("dashboard");
                }}
                className="text-white hover:text-[#999] text-xs font-medium "
              >{text.dashboard}</button>
            </li>
            <li>
              <button
                onClick={() => {
                  setTab("reward");
                }}
                className="text-white hover:text-[#999] text-xs font-medium "
              >{text.reward}</button>
            </li>
            
          </ul>
        </motion.div>
      </div>
    </>
  );
};
const fadeToRight: Variants = {
  open: {
    opacity: 1,
    x: 20,
    transition: { duration: 0.4 },
  },
  closed: { opacity: 0, x: 0, transition: { duration: 0.4 } },
};
const fadeToBelow: Variants = {
  open: {
    opacity: 1,
    y: 5,
    transition: { duration: 0.4 },
  },
  closed: { opacity: 0, y: 0, transition: { duration: 0.4 } },
};

export default Nav;
